import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PbsDataService {
  public acronym: string;
  public taskName: string;
  public formView: string;
  public statusCodeId
  public isAdmin: boolean;
  public appData: BehaviorSubject<any> = new BehaviorSubject(null);
  public formAppData: BehaviorSubject<any> = new BehaviorSubject(null);
  public educationListData: BehaviorSubject<any> = new BehaviorSubject(null);
  public isBatchActive: boolean;
  public isSaveOnly: Boolean;
  public isCategory1: Boolean;
  public isInRevision: Boolean;
  private storageKey2 = 'pbsFormAppData';
  // public appData;
  constructor() {
    // ✅ Load from localStorage when service initializes
    const savedData = localStorage.getItem(this.storageKey2);
    if (savedData) {
      this.formAppData.next(JSON.parse(savedData));
    }
  }
  // public setApplicationId(id, acronym, formView?,isAdmin?,application?,taskName?, statusCodeId?) {
  //   this.applicationId = id;
  //   this.acronym = acronym;
  //   this.taskName = taskName;
  //   this.formView = formView;
	// this.statusCodeId = statusCodeId;
	// this.application = application;
	// this.isAdmin = isAdmin;
  // }

  private readonly storageKey = 'formViewFromSideMenuPBSP';
  private storageKey2PBSP = 'pbsFormViewType';

  public setFormViewFromSideMenu(value: boolean): void {
    console.log("Setting form view:", value);
    localStorage.setItem(this.storageKey, JSON.stringify(value));
    console.log("LocalStorage after set:", localStorage.getItem(this.storageKey));
  }
  
  public getFormViewFromSideMenu(): boolean {
    const storedValue = localStorage.getItem(this.storageKey);
    console.log("Reading from LocalStorage:", storedValue);
    return storedValue ? JSON.parse(storedValue) : false;
  }
   
  

  setApplicationData(data){
    this.appData.next(data);
  }

  getApplicationData():Observable<any> {
    return this.appData.asObservable();
  }

  // setFormAppData(data){
  //   if(data){
  //   this.formAppData.next({acronym:data.processAcronym, appId:data.applicationId, formViewType: data.viewType, statusCodeId: data.statusId})
  //   }else if(data == null){
  //     this.formAppData.next(data)
  //   }
  // }
  // getFormAppData():Observable<any>{
  //   return this.formAppData.asObservable();
  // }

  // ✅ Save to BehaviorSubject + localStorage
  setFormAppData(data: any): void {
    if (data) {
      const formattedData = {
        acronym: data.processAcronym,
        appId: data.applicationId,
        formViewType: data.viewType,
        statusCodeId: data.statusId,
      };
      this.formAppData.next(formattedData);
      localStorage.setItem(this.storageKey2, JSON.stringify(formattedData));
    } else {
      this.formAppData.next(null);
      localStorage.removeItem(this.storageKey2);
    }
  }

  // ✅ Observable for components to subscribe
  getFormAppData(): Observable<any> {
    return this.formAppData.asObservable();
  }

  setEducationData(data){
    if(data)
    this.educationListData.next(data);
  }

  getEducationData():Observable<any>{
    return this.educationListData.asObservable();
  }


  
}
